import { TabSearchIcon } from './TabSearchIcon';

/**
 * author: Arno Cellarier
 * id BF6060AC-37F8-4236-B9D1-0C37A9AF09E9
 * name tab-search
 * version: 6.5.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/tab-search.svg
 * tags
 */
export const TabFindIcon = TabSearchIcon;
export default TabFindIcon